import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,} from "@material-ui/core";
import {useEffect, useState} from "react";

const UpdateMedicine = ({open, onClose, medicine, onSave}) => {
  const [formData, setFormData] = useState({...medicine});

  useEffect(() => {
    setFormData({...medicine});
  }, [medicine]);

  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData((prev) => ({...prev, [name]: value}));
  };

  const handleSave = () => {
    const cleanedData = {
      ...formData,
      medicineName: formData.medicineName.trim(),
      dosage: formData.dosage?.trim() || "",
      frequency: formData.frequency?.trim() || "",
      instruction: formData.instruction?.trim() || "",
    };

    if (!formData.medicineName?.trim()) {
      alert("Medicine Name is required.");
      return;
    }

    onSave(cleanedData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>View / Edit Medicine</DialogTitle>
      <DialogContent dividers>
        <TextField
          name="medicineName"
          label="Medicine Name"
          value={formData.medicineName}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          name="dosage"
          label="Dosage"
          value={formData.dosage}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          name="frequency"
          label="Frequency"
          value={formData.frequency}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          name="instruction"
          label="Instruction"
          value={formData.instruction}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateMedicine;
